import * as ReselectModule from "reselect";
import { IUserListState } from ".";
import { IApplicationState } from "..";

export const selectUserList: ReselectModule.Selector<
  IApplicationState,
  IUserListState
> = (state) => state.userList;
